import * as types from "redux/types";


const initialState = {
  getIndexNumber: 1,
  messagesList: []
};


const indexReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.CHANGE_AICHAT: {
      const { prop, value } = payload;
      return {
        ...state,
        [prop]: value,
      };
    }
    case types.CHANGE_AICHAT_LIST: {
      const { items, _meta } = payload;

      var newItems = []
      var addedItems = []
      newItems = [...state.messagesList]

      if (newItems?.length === 0) {
        newItems = items?.reverse()
      } else {
        for (const apiChat of items) {

          if (apiChat?.message_id !== newItems[newItems?.length - 1]?.message_id) {

            addedItems.push(apiChat)
          } else {
            break;
          }
        }

        newItems = newItems.concat(addedItems);

      }

      return {
        ...state,
        messagesList: newItems,
        messagesPage: _meta
      };
    }
    case types.CHANGE_AICHAT_ADD_END: {
      const { item } = payload;
      var newItems = []
      newItems = [...state.messagesList]
      newItems?.push(item)
      console.log(newItems);
      return {
        ...state,
        messagesList: newItems,

      };
    }
    case types.CHANGE_AICHAT_REPLACE_END: {
      const { item } = payload;
      var newItems = []
      newItems = [...state.messagesList]
      newItems.pop()
      newItems?.push(item)
      return {
        ...state,
        messagesList: newItems,
      };
    }
    case types.CHANGE_AICHAT_PAGE_LIST: {
      const { items, _meta } = payload;
      var newItems = []
      newItems = [...state.messagesList]
      console.log("messagesList");
      console.log(newItems);
      newItems.unshift(...items.reverse());
      console.log("newItems");
      console.log(newItems);

      return {
        ...state,
        messagesList: newItems,
        messagesPage: _meta
      };
    }
    default:
      return state;
  }
};



export default indexReducer;
